import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

export default function relatetaskreducer(state = initialstate.relateTask, action) {
    switch (action.type) {
		case actions.GET_DOCUMENT_AVAILABLE_TASKS: {
            if(action.response && !action.error){
				const taskList =
					action.response.taskGroups && action.response.taskGroups.length > 0
						? action.response.taskGroups[0].tasks
						: [];

				return {
                    ...state,
                    ...Utility.normalize(taskList, undefined, 'id')
                }
            }
            return state;
        }
        case actions.GET_DOCUMENT_RELATED_TASKS: {
            if(action.response && !action.error){
                return {
                    ...state,
                    document: {
                        ...action.response,
                        tasks: action.response.tasks.map((x) => x.id)
                    }
                }
            }
        }
        case actions.RELATE_TASK_TO_DOCUMENT: {
            if(action.response && !action.error){
                return {
                    ...state,
                    document: {
                        ...state.document,
                        tasks: [...state.document.tasks, action.taskId]
                    }
                }
            }
        }
        case actions.UNRELATE_TASK_FROM_DOCUMENT: {
            if(action.response && !action.error){
                return {
                    ...state,
                    document: {
                        ...state.document,
                        tasks: state.document.tasks.filter((t) => t.taskId !== action.taskId)
                    }
                }
            }
        }
        default: 
            return state;
    }
}